import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
//Don't allow 34cm deep SKUBB storage boxes on 58cm deep frames/shelves
export class SkubbBoxPlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'BoxAndMatsPlacementValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (this.coreApi.entities.isProductType(entity, ProductType.PAX_SKUBB_STORAGE_BOXES)) {
            const boxDepth = this.coreApi.entities.getEntityComSize(entity)?.depth;
            const snapActionCandidateDepth = this.coreApi.entities.getEntityComSize(snapActionCandidate.host)?.depth;
            return snapActionCandidateDepth === 580 && boxDepth === 340
                ? this.validationFail('Can not place skubb on shelf')
                : this.validationOK();
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=SkubbBoxPlacementValidation.js.map